import styled, { css } from "styled-components";

export const StyledRatingStarsContainer = styled.div`
    display: inline-flex;
    align-items: center;
`;

export const StyledRatingStars = styled.div`
    display: inline-flex;
    align-items: center;
    .star {
        padding: 0 1px;
        &.active {
            use {
                fill: ${({theme}) => theme.colors.orange};
            }
        }
    }
    ${({ interactive }) => interactive && css`
        .star {
            cursor: pointer;
        }
    `}
`;